export const storeInitUser = (user) => ({
  type: "INIT_USER",
  payload: user,
});

export const changeClass = (newClass) => ({
  type: "CHANGE_CLASS", // change subgroup
  payload: { subgroup: newClass },
});
